module.exports = __webpack_public_path__ + "img/rub.63cd5c96.svg";